import React from 'react';

import { formatMoney } from 'helpers/fieldsHelpers';
import { TextLine } from '../lineTemplates';

export const Money = props => (
    <TextLine value={props.value ? formatMoney(props.value) : ''} />
);
